import React from 'react';
import PropTypes from 'prop-types';
import {HintsModal} from './HintsModal';
import {SlideBlockContext} from '../SlideBlock';
import {Modal} from '@learningblocks/shared-components';
import './style.scss';

const ENTER_KEY = 13;

/**
 * HintsBlock:
 *  - The small round component at the bottom right of DesignSection.
 *    Applying a hint will automatically answer a step of DesignSide
 */
export function HintsBlock(props) {
  const [modalOpen, setModalOpen] = React.useState(false);

	const {getTabIndex} = React.useContext(SlideBlockContext);

  const open = () => setModalOpen(true);

  const close = () => setModalOpen(false);

  const applyHint = () => {
    props.applyHint();
    close();
  };

  const onKeyDown = (event) => event.keyCode === ENTER_KEY && open();

  const getHintsLeft = () => props.hintsAllowed - props.hintsUsed;

  const showModal = () => modalOpen && getHintsLeft() > 0;

  const renderModal = () =>
    showModal() ? (
      <Modal isOpen={true} size='sm' contentLabel='Hints Modal'>
        <HintsModal
          hintsLeft={getHintsLeft()}
          onYes={applyHint}
          onNo={close}
          message={props.message}
        />
      </Modal>
    ) : null;

  if (props.visible) {
    return (
      <>
        <div
          tabIndex={getTabIndex()}
          className='hints-popup'
          onClick={open}
          onKeyDown={onKeyDown}>
          <span>
            {getHintsLeft()} /{props.hintsAllowed}
          </span>
          <span>Hints</span>
        </div>
        {renderModal()}
      </>
    );
  } else {
    return null;
  }
}

HintsBlock.propTypes = {
  /**
   * Boolean specifying if HintsBlock should be displayed
   */
  visible: PropTypes.bool,
  /**
   * Function involked when hints need to be applied
   */
  applyHint: PropTypes.func,
  /**
   * Number of hints already used.
   */
  hintsUsed: PropTypes.number.isRequired,
  /**
   * Total number of hints allowed
   */
  hintsAllowed: PropTypes.number.isRequired,
  /**
   * Message to be displayed on Hints Modal
   */
  message: PropTypes.string,
};

HintsBlock.defaultProps = {
  visible: true,
  hintsUsed: 0,
  hintsAllowed: 0,
};
